import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpService} from '../../../../../../../core';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, Validators} from '@angular/forms';
import {Constants} from '../../../../../../../core/services/constants.service';


@Component({
  selector: 'app-lawyer-info-create',
  templateUrl: './lawyer-info-create.component.html',
  styleUrls: ['./lawyer-info-create.component.scss']
})

export class LawyerInfoCreateComponent implements OnInit {
  submitted: any;
  lawyerInfoForm: any;

  constants = Constants;



  constructor(private dialogRef: MatDialogRef<any>,
              private httpService: HttpService,
              private toastrService: ToastrService,
              private fb: FormBuilder,
              private cdr: ChangeDetectorRef,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.lawyerInfoForm = this.fb.group({
      firstName: ['', [
        Validators.required,
        Validators.minLength(Constants.MIN_FIRSTNAME_LENGTH),
        Validators.maxLength(Constants.MAX_FIRSTNAME_LENGTH)
      ]],
      lastName: ['', [
        Validators.required,
        Validators.minLength(Constants.MIN_LASTNAME_LENGTH),
        Validators.maxLength(Constants.MAX_LASTNAME_LENGTH)
      ]],
      email: ['', [
        Validators.required,
        Validators.pattern(Constants.EMAIL_REGEX),
        Validators.maxLength(Constants.MAX_EMAIL_LENGTH)
      ]],
      phoneNumber: ['', [
        Validators.required,
        Validators.pattern(Constants.PHONE_REGEX),
        Validators.minLength(Constants.MIN_PHONE_NUMBER_LENGTH),
        Validators.maxLength(Constants.MAX_PHONE_NUMBER_LENGTH)
      ]],
     lawFirm: ['', [
       Validators.maxLength(Constants.MAX_COMPANYNAME_LENGTH)
     ]]
    });
  }

  ngOnInit(): void {
    console.log(this.data.property);
  }

  get f() {
    return this.lawyerInfoForm.controls;
  }

  submit() {
    this.submitted = true;
    if (this.lawyerInfoForm.invalid) {
      return;
    }

    const fd = new FormData();
    fd.append('propertyId', this.data.property.id);
    fd.append('firstName', this.lawyerInfoForm.get('firstName').value);
    fd.append('lastName', this.lawyerInfoForm.get('lastName').value);
    fd.append('phoneNumber', this.lawyerInfoForm.get('phoneNumber').value);
    fd.append('email', this.lawyerInfoForm.get('email').value);
    fd.append('companyName', this.lawyerInfoForm.get('lawFirm').value);


    this.httpService.createLawyerInfo(fd).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.toastrService.success('Lawyer has been created');
        this.dialogRef.close({code: 1, lawyer: res.data});
      } else {
        this.toastrService.error('Failed to add Lawyer');
      }
    });

  }



}
